import { Cirus } from "@/classes/Http";
import { IsNumber, IsOptional, IsString, IsUUID, MinLength, validate } from "class-validator";
import { Message } from "element-ui";

const errorMessages : any = {
    id: "لطفا بعدا دوباره تلاش کنید.",
    name: "لطفا نام را وارد کنید. حداقل دو حرف.",
    price: "لطفا هزینه را وارد کنید.",
}

class CreateMethodBody {
    constructor (body: CreateMethodBody) {
        this.id = body.id;
        this.name = body.name;
        this.price = body.price || 0;
    }
    @IsUUID()
    @IsOptional()
    id: string;

    @IsString()
    @MinLength(2)
    name: string;

    @IsNumber()
    price: number;
}

export async function createInstanceDeliveryMethod(instance_id: number, params: CreateMethodBody) {
    params = new CreateMethodBody(params);    
    const errors = await validate(params);
    if (errors.length>0)  {
        console.log(errors);
        
        Message.error(errorMessages[errors[0].property])
        throw new Error("اطلاعات وارد شده صحیح نمی ‌باشد.");
    }
    const path = `/instance/${instance_id}/delivery-method`;
    return Cirus.put(path, params);
}